<template>
  <el-dialog
      :visible="visible"
      v-on:close="$emit('update:visible', false)"
      center
      width="500px"
      title="Archive Campaign"
  >
    <div class="text-center">
      <img class="inline"
           :src="require('../../assets/images/delete-impact-post.svg')"
           width="247px"
           height="207px"
           alt="Message Sent">
      <div class="text-sm opacity-80 mx-10 sm:mx-4 -mt-6">
        This campaign will no longer be visible by donors.
        However, you can unarchive it to display it again
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="flex justify-between">
        <el-button size="medium" @click="$emit('update:visible', false)">Cancel</el-button>

        <el-button v-on:click="archiveCampaign(activeCampaignId); $emit('update:visible', false)"
                   type="danger"
                   size="medium"
        >Archive Campaign</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import {deleteCampaign} from "@/utils/api";
import {mapState} from "vuex";

export default {
  name: "archive-campaign-modal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeCampaignId: null
  },
  methods: {
    archiveCampaign(campaignId) {
      deleteCampaign(campaignId).then(() =>{
        this.$message('Campaign Archived');
        this.$store.dispatch('campaigns/updateCampaigns', {charity_id: this.activeCharityId, force: true});
      });
    },
  },
  computed: {
    ...mapState({
      activeCharityId: state => state.auth.activeCharityId,
    }),
  }
}
</script>
